import React from 'react';

import { locale } from '@trqk/utils';
import { LoadingSpinner } from '../..';

import { DirectedTreeEarningsPerTrack } from '../directedTree/DirectedTreeEarningsPerTrack';

/**
 * @typedef {MediaExplorerProps}
 * @property {ProIngestionDashboard} data
 * @property {string} id a unique id for the DirectedTreeEarningsPerTrack chart instance
 * @property {boolean} loading whether data is still being loaded
 */
interface MediaExplorerProps {
    data: ProDirectedTreeNode[] | null;
    id: string;
    loading: boolean;
}

const height = 500;

/**
 * Displays a DirectedTreeEarningsPerTrack chart.
 * @param props {MediaExplorerProps}
 */
export const MediaExplorer = ({
    data,
    id,
    loading,
}: MediaExplorerProps): JSX.Element => (
    <div className="bg-white rounded-lg">
        <div className="p-6">
            <div className="text-xl text-tertiary-500 font-bold tracking-wider">
                {locale.enUS.CHART_COLLECTIONS.MEDIA_EXPLORER.TITLE}
            </div>
            <div className="text-sm my-2">
                {locale.enUS.CHART_COLLECTIONS.MEDIA_EXPLORER.CTA}
            </div>
        </div>
        <hr />
        <div className="pb-6 pl-6 pr-6">
            {!loading && data !== null && (
                <DirectedTreeEarningsPerTrack
                    chartDivId={`${id}.directed-tree-earnings-per-track`}
                    data={data}
                    height={height}
                />
            )}
            {loading && (
                <div
                    className="flex items-center justify-center"
                    style={{ height }}
                >
                    <LoadingSpinner />
                </div>
            )}
        </div>
    </div>
);
